class RacedaysAddPageController {

  constructor(RacedaysService, AlertService, LoaderService, $state, Upload) {
    this.AlertService = AlertService;
    this.RacedaysService = RacedaysService;
    this.LoaderService = LoaderService;
    this.$state = $state;
    this.Upload = Upload;
  }

  $onInit() {
    var self = this;
    self.newRaceday = angular.copy(self.RacedaysService.getNew());
    self.files = {
      'header': null,
      'dynamicLink1': null,
      'dynamicLink2': null
    };
    self.validation = {};
  }

  storeFile(picFile, type) {
    this.files[type] = picFile;
  }

  save() {
    var self = this;

    if (!self.validForm()) {
      self.AlertService.error("The form has validation errors.");
      return;
    }

    self.LoaderService.start();
    self.RacedaysService.addNew(self.newRaceday, self.files)
      .then(() => {
        // empty the file array
        self.files = {};
        self.AlertService.success("New Raceday has been added");
        self.$state.go('app.racedays');
      })
      .catch((error) => {
        if (error.type === 'image') {
          self.validation = {};
          if (error.field === 'header') {
            self.files.raceday = null;
            self.validation.headerImage = error.message;
          }
          if (error.field === 'dynamicLink1') {
            self.files.dynamicLink1 = null;
            self.validation.dynamicLink1Image = error.message;
          }
          if (error.field === 'dynamicLink2') {
            self.files.dynamicLink2 = null;
            self.validation.dynamicLink2Image = error.message;
          }
          self.AlertService.error("There was a problem saving one or more of the raceday images.");
          // empty the file array
          self.files = {};
        }
        else {
          self.AlertService.error("There was a problem saving the Raceday");
        }
      })
      .finally(() => {
        self.LoaderService.stop();
      });
  }

  validForm() {
    var self = this;
    //validation

    self.validation = {};

    if (self.newRaceday.name === undefined || self.newRaceday.name === '') {
      self.validation.title = 'Title is required';
    }
    console.log(self.files);
    if (!self.files.header) {
      self.validation.headerImage = 'You need to include a Header Image';
    }
    if (self.newRaceday.date === undefined || self.newRaceday.date === '') {
      self.validation.date = 'Date is required';
    }
    if (self.newRaceday.timeDescription === undefined || self.newRaceday.timeDescription === '') {
      self.validation.timeDescription = 'Gates Open Times is required';
    }
    if (self.newRaceday.description === undefined || self.newRaceday.description === '') {
      self.validation.description = 'Information is required';
    }

    if ((!!self.newRaceday.dynamicLink1.url.trim() && !self.newRaceday.dynamicLink1.name.trim()) || (!!self.newRaceday.dynamicLink1.name.trim() && !self.newRaceday.dynamicLink1.url.trim())) {
      self.validation.dynamicLink1 = 'If using a dynamic link, both name and URL are required';
    } else if (self.newRaceday.dynamicLink1.url.length > 0 && !self.newRaceday.dynamicLink1.url.startsWith("http://") && !self.newRaceday.dynamicLink1.url.startsWith("https://")) {
      self.validation.dynamicLink1 = 'Please ensure dynamic link URL starts with http:// or https://';
    }

    if ((!!self.newRaceday.dynamicLink2.url.trim() && !self.newRaceday.dynamicLink2.name.trim()) || (!!self.newRaceday.dynamicLink2.name.trim() && !self.newRaceday.dynamicLink2.url.trim())) {
      self.validation.dynamicLink2 = 'If using a dynamic link, both name and URL are required';
    } else if (self.newRaceday.dynamicLink2.url.length > 0 && !self.newRaceday.dynamicLink2.url.startsWith("http://") && !self.newRaceday.dynamicLink2.url.startsWith("https://")) {
      self.validation.dynamicLink2 = 'Please ensure dynamic link URL starts with http:// or https://';
    }


    if (self.isEmpty(self.validation)) {
      return true;
    }
    else {
      return false;
    }

  }

  isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }

}
RacedaysAddPageController.$inject = ['RacedaysService', 'AlertService', 'LoaderService', '$state', 'Upload'];
export default RacedaysAddPageController;
